export default {
  title: {
    id: 'buyback_refurbisher_listing_no_offer_title',
    defaultMessage: 'You have no listings',
  },
  message: {
    id: 'buyback_refurbisher_listing_no_offer_message',
    defaultMessage: 'Get started by creating one now.',
  },
  createListing: {
    id: 'buyback_refurbisher_listing_no_offer_cta',
    defaultMessage: 'Create listing',
  },
  emptyStateSurtitle: {
    id: 'international_onboarding_markets_empty_state_surtitle',
    defaultMessage: 'Is it me you’re looking for?',
  },
}
